const easeInOutCubic = (progress) =>
  progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - Math.pow(-2 * progress + 2, 3) / 2;

const getSafeWindow = () => (typeof window !== "undefined" ? window : null);

const animateScrollTo = (targetY, duration = 950) => {
  const win = getSafeWindow();
  if (!win) {
    return;
  }

  if (!Number.isFinite(duration) || duration <= 0) {
    win.scrollTo(0, Math.max(0, targetY));
    return;
  }

  const startY = win.scrollY || win.pageYOffset || 0;
  const deltaY = Math.max(0, targetY) - startY;
  if (Math.abs(deltaY) < 2) {
    win.scrollTo(0, Math.max(0, targetY));
    return;
  }

  const startTime = performance.now();

  const step = (now) => {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeInOutCubic(progress);
    win.scrollTo(0, startY + deltaY * eased);

    if (progress < 1) {
      win.requestAnimationFrame(step);
    }
  };

  win.requestAnimationFrame(step);
};

export const scrollPageToTop = (duration = 950) => {
  animateScrollTo(0, duration);
};

export const scrollToElementById = (elementId, { duration = 950, offset = 120 } = {}) => {
  const win = getSafeWindow();
  if (!win) {
    return;
  }

  const element = document.getElementById(elementId);
  if (!element) {
    scrollPageToTop(duration);
    return;
  }

  const targetY = element.getBoundingClientRect().top + win.scrollY - offset;
  animateScrollTo(targetY, duration);
};
